import type { PropsWithChildren } from "react";

// This is stupid, but it's reused within the panel so...
export function SectionHeader({ children }: PropsWithChildren): JSX.Element {
  return <h6 className="text-xs text-[rgb(165,173,176)]">{children}</h6>;
}
